<template>
  <div class="picking_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row" v-if="order">
      <div class="col-lg-6 col-md-6 col-12">
        <open-cart-shipping-details
          :order="order"
          ref="shippingDetails"
        ></open-cart-shipping-details>
        <open-cart-order-details :order="order"></open-cart-order-details>
      </div>
      <div class="col-lg-6 col-md-6 col-12">
        <open-cart-picking-utility
          :order="order"
          :order-id="this.$route.params.id"
          ref="picking"
        ></open-cart-picking-utility>
      </div>
    </div>
  </div>
</template>

<script>
import OpenCartPickingUtility from "@/components/picking/OpenCartPickingUtility.vue";
import OpenCartShippingDetails from "@/components/picking/OpenCartShippingDetails.vue";
import OpenCartOrderDetails from "@/components/picking/OpenCartOrderDetails.vue";

export default {
  name: "opencart-picking",
  components: {
    OpenCartPickingUtility,
    OpenCartShippingDetails,
    OpenCartOrderDetails
  },
  data() {
    return {
      order: null,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Orders", to: { name: "orders" } },
        { text: "Order", to: { name: "order" } },
        { text: "Picking", active: true }
      ],
      editables: {
        shipping_method: "",
        telephone: ""
      },
      editablesSubmitted: false
    };
  },
  mounted: function() {
    this.getPickingOrder("picking");
  },
  methods: {
    getPickingOrder(source) {
      let loader = this.$loading.show();
      this.$http
        .get(
          this.APIURL + this.BRAND + "/order-picking/" + this.$route.params.id
        )
        .then(
          response => {
            this.order = response.data;
            this.editables.shipping_method = this.order.shipping_method;
            this.editables.telephone = this.order.telephone;
            if (this.order.item_missing_from_stock) {
              setTimeout(() => {
                this.$refs.picking.error =
                  "Not all items on this order exist in stock / or stock is lower than needed";
              }, 100);
            } else {
              setTimeout(() => {
                this.$refs.picking.getNextItemToPick();
                //TODO
                if (source == "picking") {
                  this.$refs.picking.printPickingNote();
                  this.$refs.picking.$refs.model.focus();
                }
              }, 100);
            }
            loader.hide();
          },
          error => {
            this.loading = false;
            loader.hide();
            console.log(error);
          }
        );
    }
  }
};
</script>
